/**
 * Wait for all data required before the Zoraxy loading screen is dismissed.
 * Secondary tabs are warmed in the background by ChatList; they must not
 * block the first visible conversation list.
 */
export const waitForZoraxyCriticalData = ({
  conversations,
  stats,
  menuData,
  secondaryTabs,
}) => {
  // Consume a background rejection without making it part of the critical
  // startup barrier. The tab cache remains useful if one tab fails.
  Promise.resolve(secondaryTabs).catch(() => null);
  const requests = [conversations, stats, menuData];
  return Promise.allSettled(requests);
};
